/**
 * Message type enumeration for notifications and alerts
 */
export enum MessageType {
  TransactionConflict = 'transaction_conflict',
  IncomeConflict = 'income_conflict',
  SyncError = 'sync_error',
  SyncSuccess = 'sync_success',
  Info = 'info',
  Warning = 'warning',
}

/**
 * Check if a message type is actionable (requires user action)
 */
export function isActionableMessageType(type: MessageType): boolean {
  return [
    MessageType.TransactionConflict,
    MessageType.IncomeConflict,
  ].includes(type);
}
